<nz-collapse [nzBordered]="false" nzGhost nzExpandIconPosition="right" [dir]="direction">
  <nz-collapse-panel
    #panel
    [nzHeader]="!headerTemplate ? (headerKey | translate: locale.language) : headerTemplate"
    [nzActive]="active"
    (nzActiveChange)="onActiveChange($event)"
    [nzExpandedIcon]="expandedIcon"
  >
    <ng-content></ng-content>
    <ng-template #expandedIcon let-active>
      <i class="ant-collapse-arrow" nz-icon nzType="images:drop" [nzRotate]="panel.nzActive ? 180 : 0"></i>
    </ng-template>
  </nz-collapse-panel>
</nz-collapse>
